/**
 * URQL Provider
 *
 * Wraps the app with URQL client context.
 * Handles client recreation on auth changes.
 */

import { Provider } from "urql";
import { useMemo, type ReactNode } from "react";
import { getUrqlClient } from "./client";

interface UrqlProviderProps {
  children: ReactNode;
}

/**
 * URQL Provider component.
 * Uses singleton client that can be reset on auth changes.
 */
export function UrqlProvider({ children }: UrqlProviderProps) {
  const client = useMemo(() => getUrqlClient(), []);

  return <Provider value={client}>{children}</Provider>;
}
